// import { useState, useMemo } from "react";
// import "./InquiryForm.css"; // reuse existing global styles if needed

// const RAW_CONFERENCES = [
//   ["May 11, 2026", "International Conference on Nuclear Medicine and Biology", "ICNMB", "Amsterdam", "Netherlands"],
//   ["July 29, 2026", "International Conference on Nuclear Medicine and Biology", "ICNMB", "Zurich", "Switzerland"],
//   ["August 23, 2026", "International Conference on Gender, Sex and Healthcare", "ICGSH", "Budapest", "Hungary"],
//   ["August 05, 2026", "International Conference on Gender, Sex and Healthcare", "ICGSH", "Vancouver", "Canada"],
//   ["August 12, 2026", "International Conference on Gender, Sex and Healthcare", "ICGSH", "Venice", "Italy"],
//   ["August 16, 2026", "International Conference on Gender, Sex and Healthcare", "ICGSH", "Istanbul", "Turkey"],
//   ["June 15, 2026", "International Conference on Gender, Sex and Healthcare", "ICGSH", "Montreal", "Canada"],
//   ["August 30, 2026", "International Conference on Gender, Sex and Healthcare", "ICGSH", "Moscow", "Russia"],
//   ["June 15, 2026", "International Conference on Neurology and Epidemiology", "ICNE", "Riga", "Latvia"],
//   ["August 16, 2026", "International Conference on Neurology and Epidemiology", "ICNE", "Istanbul", "Turkey"],
//   ["June 15, 2026", "International Conference on Neurology and Epidemiology", "ICNE", "Montreal", "Canada"],
//   ["August 30, 2026", "International Conference on Neurology and Epidemiology", "ICNE", "Moscow", "Russia"],
//   ["June 15, 2026", "International Conference on Anesthesiology and Critical Care Medicine", "ICACCM", "Riga", "Latvia"],
//   ["June 15, 2026", "International Conference on Anesthesiology and Critical Care Medicine", "ICACCM", "Toronto", "Canada"],
//   ["August 16, 2026", "International Conference on Anesthesiology and Critical Care Medicine", "ICACCM", "Istanbul", "Turkey"],
//   ["June 15, 2026", "International Conference on Anesthesiology and Critical Care Medicine", "ICACCM", "Montreal", "Canada"],
//   ["August 30, 2026", "International Conference on Anesthesiology and Critical Care Medicine", "ICACCM", "Moscow", "Russia"],
//   ["June 15, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Riga", "Latvia"],
//   ["July 22, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Tokyo", "Japan"],
//   ["July 19, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Paris", "France"],
//   ["June 08, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Tokyo", "Japan"],
//   ["August 16, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Barcelona", "Spain"],
//   ["May 11, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Sydney", "Australia"],
//   ["July 15, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Stockholm", "Sweden"],
//   ["May 18, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "London", "United Kingdom"],
//   ["August 12, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Venice", "Italy"],
//   ["July 29, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Vienna", "Austria"],
//   ["July 12, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Ottawa", "Canada"],
//   ["August 16, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Tokyo", "Japan"],
//   ["June 15, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Riga", "Latvia"],
//   ["July 22, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Tokyo", "Japan"],
//   ["July 19, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Paris", "France"],
//   ["June 08, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Tokyo", "Japan"],
//   ["August 16, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Barcelona", "Spain"],
//   ["May 11, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Sydney", "Australia"],
//   ["July 15, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Stockholm", "Sweden"],
//   ["May 18, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "London", "United Kingdom"],
//   ["August 12, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Venice", "Italy"],
//   ["July 29, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Vienna", "Austria"],
//   ["July 12, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Ottawa", "Canada"],
//   ["August 16, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Tokyo", "Japan"],
//   ["May 04, 2026", "International Conference on Biology and Medical Sciences", "ICBMS", "Istanbul", "Turkey"],
//   ["September 09, 2026", "International Conference on Biology and Medical Sciences", "ICBMS", "Tokyo", "Japan"],
//   ["September 16, 2026", "International Conference on Biology and Medical Sciences", "ICBMS", "Zurich", "Switzerland"],
//   ["April 20, 2026", "International Conference on Biology and Medical Sciences", "ICBMS", "Tokyo", "Japan"],
//   ["September 09, 2026", "International Conference on Medical Physics and Medical Sciences", "ICMPMS", "Singapore", "Singapore"],
//   ["June 15, 2026", "International Conference on Health Informatics and Health Information Management", "ICHIHIM", "Riga", "Latvia"],
//   ["August 19, 2026", "International Conference on Health Informatics and Health Information Management", "ICHIHIM", "London", "United Kingdom"],
//   ["September 09, 2026", "International Conference on Health Informatics and Health Information Management", "ICHIHIM", "Tokyo", "Japan"],
//   ["June 01, 2026", "International Conference on Health Informatics and Health Information Management", "ICHIHIM", "New York", "United States"],
// ];

// const ALL_DATA = RAW_CONFERENCES.map(([dateStr, name, abbr, city, country]) => ({
//   dateStr,
//   date: new Date(dateStr),
//   name,
//   abbr,
//   city,
//   country,
// })).sort((a, b) => a.date - b.date);

// const MONTH_NAMES = [
//   "", "January", "February", "March", "April", "May", "June",
//   "July", "August", "September", "October", "November", "December",
// ];

// function formatDate(date) {
//   return date.toLocaleDateString("en-GB", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// }

// const UNIQUE_TOPICS = [...new Set(ALL_DATA.map((d) => d.abbr))].sort();
// const UNIQUE_COUNTRIES = [...new Set(ALL_DATA.map((d) => d.country))].sort();

// const Conferences = () => {
//   const [filterTopic, setFilterTopic] = useState("");
//   const [filterCountry, setFilterCountry] = useState("");
//   const [filterMonth, setFilterMonth] = useState("");

//   const filtered = useMemo(() => {
//     return ALL_DATA.filter((d) => {
//       const matchTopic = !filterTopic || d.abbr === filterTopic;
//       const matchCountry = !filterCountry || d.country === filterCountry;
//       const matchMonth =
//         !filterMonth || d.date.getMonth() + 1 === parseInt(filterMonth);
//       return matchTopic && matchCountry && matchMonth;
//     });
//   }, [filterTopic, filterCountry, filterMonth]);

//   return (
//     <>
//       <style>{`
//         .conf-page {
//           max-width: 1100px;
//           margin: 0 auto;
//           padding: 2rem 1.5rem;
//           font-family: inherit;
//         }
//         .conf-page-header {
//           border-bottom: 1px solid #e5e7eb;
//           padding-bottom: 1rem;
//           margin-bottom: 1.5rem;
//         }
//         .conf-page-header h1 {
//           font-size: 1.6rem;
//           font-weight: 600;
//           color: #1a1a2e;
//           margin: 0 0 4px;
//         }
//         .conf-page-header p {
//           font-size: 0.9rem;
//           color: #6b7280;
//           margin: 0;
//         }
//         .conf-filters {
//           display: flex;
//           gap: 10px;
//           flex-wrap: wrap;
//           margin-bottom: 1rem;
//         }
//         .conf-filters select {
//           font-size: 0.85rem;
//           padding: 7px 12px;
//           border: 1px solid #d1d5db;
//           border-radius: 6px;
//           background: #fff;
//           color: #374151;
//           cursor: pointer;
//           outline: none;
//         }
//         .conf-filters select:focus {
//           border-color: #185FA5;
//           box-shadow: 0 0 0 2px rgba(24,95,165,0.15);
//         }
//         .conf-count {
//           font-size: 0.82rem;
//           color: #6b7280;
//           margin-bottom: 0.75rem;
//         }
//         .conf-table-wrapper {
//           overflow-x: auto;
//           border: 1px solid #e5e7eb;
//           border-radius: 8px;
//         }
//         .conf-table {
//           width: 100%;
//           border-collapse: collapse;
//         }
//         .conf-table thead tr {
//           background: #f9fafb;
//         }
//         .conf-table th {
//           font-size: 0.72rem;
//           font-weight: 600;
//           color: #6b7280;
//           text-transform: uppercase;
//           letter-spacing: 0.07em;
//           padding: 10px 16px;
//           text-align: left;
//           border-bottom: 1px solid #e5e7eb;
//           white-space: nowrap;
//         }
//         .conf-table tbody tr {
//           border-bottom: 1px solid #f3f4f6;
//           transition: background 0.12s;
//         }
//         .conf-table tbody tr:last-child {
//           border-bottom: none;
//         }
//         .conf-table tbody tr:hover {
//           background: #f0f7ff;
//         }
//         .conf-table td {
//           padding: 13px 16px;
//           font-size: 0.85rem;
//           color: #374151;
//           vertical-align: middle;
//         }
//         .conf-td-date {
//           font-weight: 600;
//           white-space: nowrap;
//           color: #1a1a2e;
//           min-width: 110px;
//         }
//         .conf-td-name {
//           min-width: 280px;
//         }
//         .conf-name-full {
//           font-weight: 500;
//           color: #1a1a2e;
//           line-height: 1.4;
//         }
//         .conf-name-abbr {
//           font-size: 0.75rem;
//           color: #6b7280;
//           margin-top: 2px;
//         }
//         .conf-td-city {
//           color: #4b5563;
//           white-space: nowrap;
//         }
//         .conf-country-badge {
//           display: inline-block;
//           font-size: 0.75rem;
//           font-weight: 500;
//           padding: 3px 10px;
//           border-radius: 999px;
//           background: #e6f1fb;
//           color: #185FA5;
//           white-space: nowrap;
//         }
//         .conf-empty {
//           text-align: center;
//           padding: 2.5rem 1rem;
//           color: #9ca3af;
//           font-size: 0.9rem;
//         }
//         @media (max-width: 600px) {
//           .conf-table th:nth-child(3),
//           .conf-table td:nth-child(3) {
//             display: none;
//           }
//         }
//       `}</style>

//       <div className="conf-page">
//         <div className="conf-page-header">
//           <h1>Upcoming Conferences</h1>
//           <p>International medical and health conferences — 2026</p>
//         </div>

//         <div className="conf-filters">
//           <select value={filterTopic} onChange={(e) => setFilterTopic(e.target.value)}>
//             <option value="">All topics</option>
//             {UNIQUE_TOPICS.map((t) => (
//               <option key={t} value={t}>{t}</option>
//             ))}
//           </select>

//           <select value={filterCountry} onChange={(e) => setFilterCountry(e.target.value)}>
//             <option value="">All countries</option>
//             {UNIQUE_COUNTRIES.map((c) => (
//               <option key={c} value={c}>{c}</option>
//             ))}
//           </select>

//           <select value={filterMonth} onChange={(e) => setFilterMonth(e.target.value)}>
//             <option value="">All months</option>
//             {[4, 5, 6, 7, 8, 9].map((m) => (
//               <option key={m} value={m}>{MONTH_NAMES[m]}</option>
//             ))}
//           </select>
//         </div>

//         <div className="conf-count">
//           {filtered.length} conference{filtered.length !== 1 ? "s" : ""} found
//         </div>

//         <div className="conf-table-wrapper">
//           <table className="conf-table">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Conference</th>
//                 <th>City</th>
//                 <th>Country</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filtered.length === 0 ? (
//                 <tr>
//                   <td colSpan={4} className="conf-empty">
//                     No conferences match the selected filters.
//                   </td>
//                 </tr>
//               ) : (
//                 filtered.map((d, i) => (
//                   <tr key={i}>
//                     <td className="conf-td-date">{formatDate(d.date)}</td>
//                     <td className="conf-td-name">
//                       <div className="conf-name-full">{d.name}</div>
//                       <div className="conf-name-abbr">{d.abbr}</div>
//                     </td>
//                     <td className="conf-td-city">{d.city}</td>
//                     <td>
//                       <span className="conf-country-badge">{d.country}</span>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Conferences;

import { useState, useMemo } from "react";

const RAW_CONFERENCES = [
  ["May 11, 2026", "International Conference on Nuclear Medicine and Biology", "ICNMB", "Amsterdam", "Netherlands"],
  ["July 29, 2026", "International Conference on Nuclear Medicine and Biology", "ICNMB", "Zurich", "Switzerland"],
  ["August 23, 2026", "International Conference on Gender, Sex and Healthcare", "ICGSH", "Budapest", "Hungary"],
  ["August 05, 2026", "International Conference on Gender, Sex and Healthcare", "ICGSH", "Vancouver", "Canada"],
  ["August 12, 2026", "International Conference on Gender, Sex and Healthcare", "ICGSH", "Venice", "Italy"],
  ["August 16, 2026", "International Conference on Gender, Sex and Healthcare", "ICGSH", "Istanbul", "Turkey"],
  ["June 15, 2026", "International Conference on Gender, Sex and Healthcare", "ICGSH", "Montreal", "Canada"],
  ["August 30, 2026", "International Conference on Gender, Sex and Healthcare", "ICGSH", "Moscow", "Russia"],
  ["June 15, 2026", "International Conference on Neurology and Epidemiology", "ICNE", "Riga", "Latvia"],
  ["August 16, 2026", "International Conference on Neurology and Epidemiology", "ICNE", "Istanbul", "Turkey"],
  ["June 15, 2026", "International Conference on Neurology and Epidemiology", "ICNE", "Montreal", "Canada"],
  ["August 30, 2026", "International Conference on Neurology and Epidemiology", "ICNE", "Moscow", "Russia"],
  ["June 15, 2026", "International Conference on Anesthesiology and Critical Care Medicine", "ICACCM", "Riga", "Latvia"],
  ["June 15, 2026", "International Conference on Anesthesiology and Critical Care Medicine", "ICACCM", "Toronto", "Canada"],
  ["August 16, 2026", "International Conference on Anesthesiology and Critical Care Medicine", "ICACCM", "Istanbul", "Turkey"],
  ["June 15, 2026", "International Conference on Anesthesiology and Critical Care Medicine", "ICACCM", "Montreal", "Canada"],
  ["August 30, 2026", "International Conference on Anesthesiology and Critical Care Medicine", "ICACCM", "Moscow", "Russia"],
  ["June 15, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Riga", "Latvia"],
  ["July 22, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Tokyo", "Japan"],
  ["July 19, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Paris", "France"],
  ["June 08, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Tokyo", "Japan"],
  ["August 16, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Barcelona", "Spain"],
  ["May 11, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Sydney", "Australia"],
  ["July 15, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Stockholm", "Sweden"],
  ["May 18, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "London", "United Kingdom"],
  ["August 12, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Venice", "Italy"],
  ["July 29, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Vienna", "Austria"],
  ["July 12, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Ottawa", "Canada"],
  ["August 16, 2026", "International Conference on Pulmonary and Respiratory Medicine", "ICPRM", "Tokyo", "Japan"],
  ["June 15, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Riga", "Latvia"],
  ["July 22, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Tokyo", "Japan"],
  ["July 19, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Paris", "France"],
  ["June 08, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Tokyo", "Japan"],
  ["August 16, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Barcelona", "Spain"],
  ["May 11, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Sydney", "Australia"],
  ["July 15, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Stockholm", "Sweden"],
  ["May 18, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "London", "United Kingdom"],
  ["August 12, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Venice", "Italy"],
  ["July 29, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Vienna", "Austria"],
  ["July 12, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Ottawa", "Canada"],
  ["August 16, 2026", "International Conference on Preventive Medicine and Integrative Medicine", "ICPMIM", "Tokyo", "Japan"],
  ["May 04, 2026", "International Conference on Biology and Medical Sciences", "ICBMS", "Istanbul", "Turkey"],
  ["September 09, 2026", "International Conference on Biology and Medical Sciences", "ICBMS", "Tokyo", "Japan"],
  ["September 16, 2026", "International Conference on Biology and Medical Sciences", "ICBMS", "Zurich", "Switzerland"],
  ["April 20, 2026", "International Conference on Biology and Medical Sciences", "ICBMS", "Tokyo", "Japan"],
  ["September 09, 2026", "International Conference on Medical Physics and Medical Sciences", "ICMPMS", "Singapore", "Singapore"],
  ["June 15, 2026", "International Conference on Health Informatics and Health Information Management", "ICHIHIM", "Riga", "Latvia"],
  ["August 19, 2026", "International Conference on Health Informatics and Health Information Management", "ICHIHIM", "London", "United Kingdom"],
  ["September 09, 2026", "International Conference on Health Informatics and Health Information Management", "ICHIHIM", "Tokyo", "Japan"],
  ["June 01, 2026", "International Conference on Health Informatics and Health Information Management", "ICHIHIM", "New York", "United States"],
];

const ALL_DATA = RAW_CONFERENCES.map(([dateStr, name, abbr, city, country]) => ({
  dateStr,
  date: new Date(dateStr),
  name,
  abbr,
  city,
  country,
})).sort((a, b) => a.date - b.date);

const UNIQUE_TOPICS = [...new Set(ALL_DATA.map((d) => d.abbr))].sort();
const UNIQUE_COUNTRIES = [...new Set(ALL_DATA.map((d) => d.country))].sort();

function formatDate(date) {
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

const Conferences = () => {
  const [filterTopic, setFilterTopic] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [filterMonth, setFilterMonth] = useState("");

  const filtered = useMemo(() => {
    return ALL_DATA.filter((d) => {
      const matchTopic = !filterTopic || d.abbr === filterTopic;
      const matchCountry = !filterCountry || d.country === filterCountry;
      const matchMonth =
        !filterMonth || d.date.getMonth() + 1 === parseInt(filterMonth);
      return matchTopic && matchCountry && matchMonth;
    });
  }, [filterTopic, filterCountry, filterMonth]);

  const uniqueCountries = new Set(ALL_DATA.map((d) => d.country)).size;
  const uniqueTopics = new Set(ALL_DATA.map((d) => d.abbr)).size;

  return (
    <>
      <style>{`
        .conf-page-bg {
          background: linear-gradient(135deg, #e8f5f0 0%, #e3f0fb 50%, #eaf3de 100%);
          min-height: 100vh;
          padding: 2rem 1rem;
        }
        .conf-inner {
          max-width: 1100px;
          margin: 0 auto;
        }
        .conf-hero {
          background: linear-gradient(120deg, #0f6e56 0%, #185FA5 100%);
          border-radius: 16px;
          padding: 2rem 2rem 1.6rem;
          margin-bottom: 1.5rem;
          border: 2px solid #0c5c45;
        }
        .conf-hero h1 {
          font-size: 1.7rem;
          font-weight: 700;
          color: #fff;
          margin: 0 0 6px;
        }
        .conf-hero p {
          font-size: 0.88rem;
          color: rgba(255,255,255,0.82);
          margin: 0;
        }
        .conf-stats {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
          gap: 10px;
          margin-bottom: 1.5rem;
        }
        .conf-stat-card {
          background: #fff;
          border: 2px solid #5DCAA5;
          border-radius: 12px;
          padding: 0.85rem 1rem;
          text-align: center;
        }
        .conf-stat-num {
          font-size: 1.6rem;
          font-weight: 700;
          color: #0f6e56;
          line-height: 1;
        }
        .conf-stat-lbl {
          font-size: 0.7rem;
          color: #4b5563;
          margin-top: 4px;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          font-weight: 600;
        }
        .conf-filters {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          margin-bottom: 1rem;
        }
        .conf-filters select {
          font-size: 0.84rem;
          padding: 9px 13px;
          border: 2px solid #0f6e56;
          border-radius: 8px;
          background: #fff;
          color: #1a1a2e;
          cursor: pointer;
          outline: none;
          font-weight: 500;
          min-width: 150px;
          flex: 1;
        }
        .conf-filters select:focus {
          border-color: #185FA5;
          box-shadow: 0 0 0 3px rgba(24,95,165,0.15);
        }
        .conf-count {
          font-size: 0.82rem;
          color: #374151;
          font-weight: 600;
          margin-bottom: 0.75rem;
        }
        .conf-table-wrap {
          background: #fff;
          border: 2px solid #0f6e56;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 4px 24px rgba(15,110,86,0.13);
          overflow-x: auto;
        }
        .conf-table {
          width: 100%;
          border-collapse: collapse;
          min-width: 500px;
        }
        .conf-table thead tr {
          background: linear-gradient(90deg, #0f6e56 0%, #185FA5 100%);
        }
        .conf-table thead th {
          font-size: 0.72rem;
          font-weight: 700;
          color: #fff;
          text-transform: uppercase;
          letter-spacing: 0.09em;
          padding: 13px 16px;
          text-align: left;
          white-space: nowrap;
        }
        .conf-table tbody tr {
          border-bottom: 1.5px solid #b5d4f4;
          transition: background 0.13s;
        }
        .conf-table tbody tr:last-child { border-bottom: none; }
        .conf-table tbody tr:nth-child(even) { background: #f0f9f6; }
        .conf-table tbody tr:hover { background: #d4f0e8; }
        .conf-table td {
          padding: 13px 16px;
          font-size: 0.84rem;
          color: #1a1a2e;
          vertical-align: middle;
        }
        .conf-td-date {
          font-weight: 700;
          white-space: nowrap;
          color: #0f6e56;
          min-width: 108px;
        }
        .conf-name-full {
          font-weight: 600;
          color: #1a1a2e;
          line-height: 1.35;
        }
        .conf-name-abbr {
          font-size: 0.72rem;
          color: #185FA5;
          font-weight: 600;
          margin-top: 3px;
        }
        .conf-td-city { color: #374151; white-space: nowrap; }
        .conf-badge {
          display: inline-block;
          font-size: 0.72rem;
          font-weight: 600;
          padding: 4px 11px;
          border-radius: 999px;
          background: linear-gradient(90deg, #e1f5ee, #e6f1fb);
          color: #0f6e56;
          border: 1.5px solid #5DCAA5;
          white-space: nowrap;
        }
        .conf-empty {
          text-align: center;
          padding: 2.5rem;
          color: #9ca3af;
          font-size: 0.9rem;
        }
        @media (max-width: 640px) {
          .conf-hero { padding: 1.25rem; }
          .conf-hero h1 { font-size: 1.2rem; }
          .conf-filters select { min-width: 100%; }
          .conf-table td, .conf-table thead th { padding: 10px 10px; font-size: 0.78rem; }
          .conf-table thead th:nth-child(3),
          .conf-table td:nth-child(3) { display: none; }
        }
      `}</style>

      <div className="conf-page-bg">
        <div className="conf-inner">

          <div className="conf-hero">
            <h1>Upcoming Conferences 2026</h1>
            <p>International medical &amp; health conferences — filter by topic, country or month</p>
          </div>

          <div className="conf-stats">
            <div className="conf-stat-card">
              <div className="conf-stat-num">{ALL_DATA.length}</div>
              <div className="conf-stat-lbl">Total Events</div>
            </div>
            <div className="conf-stat-card">
              <div className="conf-stat-num">{uniqueTopics}</div>
              <div className="conf-stat-lbl">Topics</div>
            </div>
            <div className="conf-stat-card">
              <div className="conf-stat-num">{uniqueCountries}</div>
              <div className="conf-stat-lbl">Countries</div>
            </div>
            <div className="conf-stat-card">
              <div className="conf-stat-num">2026</div>
              <div className="conf-stat-lbl">Year</div>
            </div>
          </div>

          <div className="conf-filters">
            <select value={filterTopic} onChange={(e) => setFilterTopic(e.target.value)}>
              <option value="">All topics</option>
              {UNIQUE_TOPICS.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
            <select value={filterCountry} onChange={(e) => setFilterCountry(e.target.value)}>
              <option value="">All countries</option>
              {UNIQUE_COUNTRIES.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
            <select value={filterMonth} onChange={(e) => setFilterMonth(e.target.value)}>
              <option value="">All months</option>
              {[["4","April"],["5","May"],["6","June"],["7","July"],["8","August"],["9","September"]].map(([v, l]) => (
                <option key={v} value={v}>{l}</option>
              ))}
            </select>
          </div>

          <div className="conf-count">
            {filtered.length} conference{filtered.length !== 1 ? "s" : ""} found
          </div>

          <div className="conf-table-wrap">
            <table className="conf-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Conference</th>
                  <th>City</th>
                  <th>Country</th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="conf-empty">
                      No conferences match the selected filters.
                    </td>
                  </tr>
                ) : (
                  filtered.map((d, i) => (
                    <tr key={i}>
                      <td className="conf-td-date">{formatDate(d.date)}</td>
                      <td>
                        <div className="conf-name-full">{d.name}</div>
                        <div className="conf-name-abbr">{d.abbr}</div>
                      </td>
                      <td className="conf-td-city">{d.city}</td>
                      <td><span className="conf-badge">{d.country}</span></td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </>
  );
};

export default Conferences;